import React, { Component } from 'react'
import { translate } from 'react-admin'



export default translate(({ record, translate, type }) => {

    if (record && type) {
        if (type === 'Purchase') {
            let car = record.Vehicle;
            return (<span>{`${car.year} ${car.make} ${car.model} `}</span>)
        }
        else if (type === 'Title Application') {
            let car = record.Import.Purchase.Vehicle;
            return (<span>{`${car.year} ${car.make} ${car.model} `}</span>)
        }
        else if (type === 'User') {
            let User = record;
            return (<span>{`${User.name || ''} ${User.last_name || ''} `}</span>)
        }
        else if (type === 'Conversion' || type === 'Sale' || type === 'Recall' || type === 'Repair' || type === 'Issue' || type === 'Arbitration' || type === 'Conversion' || type === 'Picture' || type === 'Docs' || type === 'PSI') {
            if (record.Purchase && record.Purchase.Vehicle) {
                let car = record.Purchase.Vehicle
                return (<span>{`${car.year} ${car.make} ${car.model} `}</span>)
            }
            else
                return (<span>{`${record.vin || ''}  `}</span>)
        }
        else if (type === 'Picture') {
            return (<span>{`Picture`}</span>)
        }
        else if (type === 'TradeRev Auto Proxy') {
            return (<span>{`${record.year || ""} ${record.make || ""} ${record.model || ""} ${record.trim || ""} ${record.vin || ""}`}</span>)
        }
        else if (type === 'Load') {
            let Load = record
            return (<span>{`Entry # ${Load.entry_number || ''}`}</span>)
        }
        else if (type === 'Load Detail') {
            let Load = record
            return (<span>{` Entry # ${Load.entry_number || ''} has ${Load.LoadDetail.length} Car(s) /`}</span>)
        }
        else if (type === 'Buyback') {
            if (record.Sale && record.Sale.Purchase && record.Sale.Purchase.Vehicle) {
                let car = record.Sale.Purchase.Vehicle
                return (<span>{`${car.year} ${car.make} ${car.model} `}</span>)
            }
        }
    }
    else if (record && !type)
        return (<span>{''}</span>)
    else
        return (<span>{'No Record Was Found!!!'}</span>)

})
